import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtRM, fmtDate } from "../../lib/format";
import { useLang } from "../../lib/i18n";
import { PageTitle, StatusBadge, Spinner } from "../../components/Shell";

export default function Billing() {
  const [data, setData] = useState(null);
  const { lang } = useLang();

  useEffect(() => {
    api.get("/platform/invoices").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <Spinner />;

  return (
    <div data-testid="platform-billing">
      <PageTitle title={lang === "bm" ? "Invois & Bayaran" : "Invoices & Payments"} sub="Enjin billing langganan platform" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-card rounded-xl border border-brand-deep/10 overflow-hidden">
          <div className="px-5 py-4 border-b border-brand-deep/10 font-display font-semibold text-brand-dark">Invois</div>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-brand-deep/5">
                <th className="px-5 py-2.5">No.</th>
                <th className="px-5 py-2.5">Keterangan</th>
                <th className="px-5 py-2.5 text-right">{lang === "bm" ? "Amaun" : "Amount"}</th>
                <th className="px-5 py-2.5">Status</th>
              </tr>
            </thead>
            <tbody>
              {data.invoices.map((inv) => (
                <tr key={inv.invoice_id} className="border-b border-brand-deep/5" data-testid={`invoice-row-${inv.number}`}>
                  <td className="px-5 py-3 font-mono text-xs">{inv.number}</td>
                  <td className="px-5 py-3 text-xs">{inv.description}<div className="text-muted-foreground">{fmtDate(inv.issued_at)}</div></td>
                  <td className="px-5 py-3 text-right font-mono font-semibold text-brand-deep">{fmtRM(inv.amount)}</td>
                  <td className="px-5 py-3"><StatusBadge status={inv.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-card rounded-xl border border-brand-deep/10 overflow-hidden">
          <div className="px-5 py-4 border-b border-brand-deep/10 font-display font-semibold text-brand-dark">Transaksi Stripe</div>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-brand-deep/5">
                <th className="px-5 py-2.5">Sesi</th>
                <th className="px-5 py-2.5">Pelan</th>
                <th className="px-5 py-2.5 text-right">Amaun</th>
                <th className="px-5 py-2.5">Status</th>
              </tr>
            </thead>
            <tbody>
              {data.transactions.length === 0 && (
                <tr><td colSpan={4} className="px-5 py-6 text-center text-sm text-muted-foreground">Tiada transaksi lagi.</td></tr>
              )}
              {data.transactions.map((tx) => (
                <tr key={tx.session_id} className="border-b border-brand-deep/5">
                  <td className="px-5 py-3 font-mono text-xs">{tx.session_id.slice(0, 18)}…</td>
                  <td className="px-5 py-3 text-xs">{tx.lookup_key}</td>
                  <td className="px-5 py-3 text-right font-mono font-semibold">{fmtRM((tx.amount_sen || 0) / 100)}</td>
                  <td className="px-5 py-3"><StatusBadge status={tx.payment_status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
